/** @jsxImportSource @emotion/react */
import { Add, Approval, ArrowDownward, ArrowDropDown, Check, Close, CropSquare, DriveFileMove, Edit, Error, Forward, Height, Input, Inventory, Print, ReceiptLong, Remove, Settings, Square, Undo } from '@mui/icons-material';
import { Box, Button, ButtonGroup, Chip, ClickAwayListener, Collapse, IconButton, InputAdornment, Paper, Popper, Stack, SvgIcon, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DataGrid, GridCellParams, GridColDef, GridSelectionModel, GridSortItem, GridSortModel, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridValueFormatterParams } from '@mui/x-data-grid';
import { ChangeEvent, Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Unstable_Grid2';

import { stripedDateGrid, textBoxInputForSmallButtons, textBoxInputStyle } from '../../../common/CustumEmotionStyles';
import { useTranslation } from 'react-i18next';

import { StatusIconVoucherRegistration, onlyUniqueListFilter, remToPixels, sortDateList } from '../../../common/CustomFunctions';

import { useDebounce } from '../../../common/CustomHooks';
import DatagridVoucherRegistrationToolbar from './DatagridVoucherRegistrationToolbar';
import DialogVoucherRegistration from './DialogVoucherRegistration';
import { IFileSortItem } from '../../../service/model/ISourceDocumentModel';
import { digiAccGuiStates } from '../../../common/TextTypes';
import { ISourceDocumentGuiModel } from '../../../model/ISourceDocumentGuiModel';
import SourceDocumentBusinessLogic from '../../../businessLogic/SourceDocumentBusinessLogic';
import { toast } from 'react-toastify';
import { CellPopper } from '../../../common/components/CellPopper';
import { format } from "date-fns";
import { nb } from "date-fns/locale";

interface IProps {
    organizationId: string,
    site: "IncomingInvoice" | "OutgoingInvoice" | "Banking" | "JournalEntries" | "Miscellaneous" | "Addition" | "Cash" | "Statement",
}


const DatagridVoucherRegistration = (props: IProps): JSX.Element => {

    const theme = useTheme();
    const [gridRows, setGridRows] = useState<any>([]);
    const [gridRowsErrors, setGridRowsErrors] = useState<string[]>([]);

    const { site } = props;

    const { t, i18n } = useTranslation();

    const [loader, setLoader] = useState(false);

    const [chosenDocument, setChosenDocument] = useState<ISourceDocumentGuiModel | undefined>()
    const [createNew, setCreateNew] = useState(false);
    const handleDialogOpen = (document: ISourceDocumentGuiModel | undefined, newDocument: boolean) => {
        if (document) {
            if (newDocument) {
                setCreateNew(true);
            }
            setChosenDocument(document);
        } else {
            toast(t("Missing document"));
        }
    }
    let openDialog = chosenDocument ? true : false;
    const handleDialogClose = () => {
        setChosenDocument(undefined);
        setCreateNew(false);
        handleClearAndUpdateDatagrid();
    }


    const handlePrint = () => {

    }
    const handleNewDocument = () => {

        let newDocument: ISourceDocumentGuiModel = {
            id: 0,
            batchId: undefined,
            type: "Miscellaneous",
            comments: "",
            status: "InProgress",
            createdDate: null,
            createdBy: undefined,
            modifiedDate: null,
            modifiedBy: undefined,
            originalSourceDocumentId: undefined,
            correctionComments: undefined,
            voucherId: undefined,
            source: 0,
            lines: undefined,
            approvalRequests: undefined,
            files: [],
        }

        handleDialogOpen(newDocument, true);
    }
    const handleClearAndUpdateDatagrid = () => {
        setVoucherRegistrationSelection([]);
        getData(true);
    }
    const handleCorrect = () => {

    }
    const [searchSimple, setSimpleSearch] = useState("");
    const debouncedSearchSimple = useDebounce(searchSimple, 700);
    const handleSearchSimple = (text: string) => {
        setSimpleSearch(text)
    }

    //##################################################################
    const [openAdvancedSearch, setOpenAdvancedSearch] = useState(false);

    const handleOpenAdvnacedSearchToggle = () => {
        setOpenAdvancedSearch((prevOpen) => !prevOpen);
    }

    //##################Datagrid params
    const [voucherRegistrations, setVoucherRegistrations] = useState<ISourceDocumentGuiModel[]>([]);
    const [voucherRegistrationPageNum, setVoucherRegistrationPageNum] = useState(0);
    const [voucherRegistrationLimitPerPage, setVoucherRegistrationLimitPerPage] = useState(100);
    const [voucherRegistrationTotalPages, setVoucherRegistrationTotalPages] = useState(0);
    const [voucherRegistrationTotalItems, setVoucherRegistrationTotalItems] = useState(0);

    const [voucherRegistrationSelection, setVoucherRegistrationSelection] = useState<GridSelectionModel>([])
    //#################
    const [status, setStatus] = useState<digiAccGuiStates | undefined>("All");

    const handleUpdateStatus = (status: digiAccGuiStates) => {
        setStatus(status);
    }

    const [invoiceNo, setInvoiceNo] = useState<string>("");
    const handleInvoiceNo = (invoiceNo: string) => {
        setInvoiceNo(invoiceNo)
    }
    const debouncedInvoiceNo = useDebounce(invoiceNo, 700);
    //##
    const [voucherDateFrom, setVoucherDateFrom] = useState<Date | undefined>();
    function handleVoucherDateFrom(newDate?: Date) {
        setVoucherDateFrom(newDate);
    }
    const [voucherDateTo, setVoucherDateTo] = useState<Date | undefined>();
    function handleVoucherDateTo(newDate?: Date) {
        setVoucherDateTo(newDate);
    }
    //##
    const [dueDateFrom, setDueDateFrom] = useState<Date | undefined>();
    function handleDueDateFrom(newDate?: Date) {
        setDueDateFrom(newDate);
    }
    const [dueDateTo, setDueDateTo] = useState<Date | undefined>();
    function handleDueDateTo(newDate?: Date) {
        setDueDateTo(newDate);
    }
    //##
    const [amountFrom, setAmountFrom] = useState<string>("");
    const handleAmountFrom = (amount: string) => {
        setAmountFrom(amount);
    }
    const debouncedAmountFrom = useDebounce(amountFrom, 700);
    const [amountTo, setAmountTo] = useState<string>("");
    const handleAmountTo = (amount: string) => {
        setAmountTo(amount);
    }
    const debouncedAmountTo = useDebounce(amountTo, 700);
    //##
    const [voucherNoFrom, setVoucherNoFrom] = useState<string>("");
    const handleVoucherNoFrom = (voucherNo: string) => {
        setVoucherNoFrom(voucherNo);
    }
    const debouncedVoucherNoFrom = useDebounce(voucherNoFrom, 700);
    const [voucherNoTo, setVoucherNoTo] = useState<string>("");
    const handleVoucherNoTo = (voucherNo: string) => {
        setVoucherNoTo(voucherNo);
    }
    const debouncedVoucherNoTo = useDebounce(voucherNoTo, 700);

    const [debet, setDebet] = useState<string>("");
    const handleDebet = (debet: string) => {
        setInvoiceNo(debet)
    }
    const debouncedDebet = useDebounce(debet, 700);

    const [credit, setCredit] = useState<string>("");
    const handleCredit = (credit: string) => {
        setCredit(credit)
    }
    const debouncedCredit = useDebounce(credit, 700);

    const [department, setDepartment] = useState<string>("");
    const handleDepartment = (department: string) => {
        setDepartment(department)
    }
    const debouncedDepartment = useDebounce(department, 700);

    const [project, setProject] = useState<string>("");
    const handleProject = (project: string) => {
        setProject(project)
    }
    const debouncedProject = useDebounce(project, 700);

    const [valueDateFrom, setValueDateFrom] = useState<Date | undefined>();
    function handleValueDateFrom(newDate?: Date) {
        setValueDateFrom(newDate);
    }
    const [valueDateTo, setValueDateTo] = useState<Date | undefined>();
    function handleValueDateTo(newDate?: Date) {
        setValueDateTo(newDate);
    }
    const [createdDateFrom, setCreatedDateFrom] = useState<Date | undefined>();
    function handleCreatedDateFrom(newDate?: Date) {
        setCreatedDateFrom(newDate);
    }
    const [createdDateTo, setCreatedDateTo] = useState<Date | undefined>();
    function handleCreatedDateTo(newDate?: Date) {
        setCreatedDateTo(newDate);
    }
    const [comment, setComment] = useState<string>("");
    const handleComment = (comment: string) => {
        setComment(comment)
    }
    const debouncedComment = useDebounce(comment, 700);

    const [sortDocumentItem, setSortDocumentItem] = useState<IFileSortItem | null>();

    //##################

    const getData = async (isMounted: boolean) => {

        const logic = new SourceDocumentBusinessLogic();

        setLoader(true);  //Loader for datagrid

        const result = await logic.getSourceDocuments(
            props.organizationId,
            voucherRegistrationPageNum,
            voucherRegistrationLimitPerPage,
            voucherDateFrom,
            voucherDateTo,
            dueDateFrom,
            dueDateTo,
            valueDateFrom,
            valueDateTo,
            createdDateFrom,
            createdDateTo,
            ["Transferred","AdditionTransferred", "AwaitingForDataEntry", "AwaitingForTransfer", "InProgress", "Rejected" ], //Show everything, just not approval stuff for this component.
            props.site, //This refers to the vouchertype from the given site
            debouncedInvoiceNo,
            debouncedDebet,
            debouncedCredit,
            debouncedDepartment,
            debouncedProject,
            debouncedVoucherNoFrom,
            debouncedVoucherNoTo,
            debouncedAmountFrom,
            debouncedAmountTo,
            debouncedSearchSimple,
            //sortDocumentItem ? sortDocumentItem : undefined,

        );
        if (!result.hasErrors) {
            if (isMounted) {

                setVoucherRegistrations(result.value)

                let rows = result.value ? result.value.map(elem => {
                    return {
                        id: elem.id,
                        status: elem.status,
                        invoiceNo: [...new Set(elem.lines?.map(e => e.invoiceNo).filter(e => e && e !== ""))].join(",\n"),
                        voucherDate: [...new Set(elem.lines?.
                            map(e => e.voucherDate ? new Date(e.voucherDate).toISOString() : ""))].
                            filter(e => e !== "").
                            sort(sortDateList).map(e => format(new Date(e), 'dd.MM.yyyy', { locale: nb })).
                            join(",\n"),
                        dueDate: [...new Set(elem.lines?.
                            map(e => e.dueDate ? new Date(e.dueDate).toISOString() : ""))].
                            filter(e => e !== "").
                            sort(sortDateList).map(e => format(new Date(e), 'dd.MM.yyyy', { locale: nb })).
                            join(",\n"),
                        amount: elem.lines?.filter(e => e.debitAccount !== null && e.debitAccount !== undefined).map(e => e.amount ? e.amount : 0).reduce((acc, value) => { return acc + value }, 0),
                        voucherId: elem.voucherId,
                        debitAccount: [...new Set(elem.lines?.map(e => e.debitAccount ? e.debitAccount.name + " (" + e.debitAccount.accountId + ")" : "").filter(e => e && e !== ""))].join(",\n"),
                        creditAccount: [...new Set(elem.lines?.map(e => e.creditAccount ? e.creditAccount.name + " (" + e.creditAccount.accountId + ")" : "").filter(e => e && e !== ""))].join(",\n"),
                        department: [...new Set(elem.lines?.map(e => e.department ? e.department.name + " (" + e.department.departmentId + ")" : "").filter(e => e && e !== ""))].join(",\n"),
                        project: [...new Set(elem.lines?.map(e => e.project ? e.project.name + " (" + e.project.projectId + ")" : "").filter(e => e && e !== ""))].join(",\n"),
                        valueDate: [...new Set(elem.lines?.
                            map(e => e.valueDate ? new Date(e.valueDate).toISOString() : ""))].
                            filter(e => e !== "").
                            sort(sortDateList).map(e => format(new Date(e), 'dd.MM.yyyy', { locale: nb })).
                            join(",\n"),
                        type: elem.type,
                        createdDate: elem.createdDate ? format(elem.createdDate, 'dd.MM.yyyy', { locale: nb }) : undefined,
                        comment: elem.comments,
                    }
                }) : [];

                setGridRows(rows)

                setVoucherRegistrationTotalPages(result.totalPages);
                setVoucherRegistrationTotalItems(result.totalItems);
                setGridRowsErrors([])
            }
        } else {
            setGridRowsErrors(result.errors);
        }
        setLoader(false);
    };

    useEffect(() => {
        let isMounted = true; //Avoid memory leaks. Async function running after dismount.

        getData(true);

        return () => { isMounted = false };
    }, [
        props.organizationId,
        voucherRegistrationPageNum,
        voucherRegistrationLimitPerPage,
        voucherDateFrom,
        voucherDateTo,
        dueDateFrom,
        dueDateTo,
        valueDateFrom,
        valueDateTo,
        createdDateFrom,
        createdDateTo,
        status,
        props.site,
        debouncedInvoiceNo,
        debouncedDebet,
        debouncedCredit,
        debouncedDepartment,
        debouncedProject,
        debouncedVoucherNoFrom,
        debouncedVoucherNoTo,
        debouncedAmountFrom,
        debouncedAmountTo,
        debouncedSearchSimple,
        sortDocumentItem,
    ]);

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'id', width: 120, hide: true},
        {
            field: 'status', headerName: 'Status', width: 60, align: "center",
            renderCell: (params: GridCellParams) => <StatusIconVoucherRegistration status={params.value} />
        },
        { field: 'invoiceNo', headerName: t('search.invoiceId'), width: 120, sortable: false, renderCell: CellPopper, },
        { field: 'voucherDate', headerName: t('search.voucherDate'), width: 105, sortable: false, renderCell: CellPopper, },
        { field: 'dueDate', headerName: t('search.dueDate'), width: 105, sortable: false, renderCell: CellPopper, },
        {
            field: 'amount', headerName: t('search.amount'), width: 120, align: "right",
            valueFormatter: (params: GridValueFormatterParams<number>) => {
                if (params.value == null) {
                    return "";
                }
                return new Intl.NumberFormat('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value);
            }
        },
        {
            field: 'voucherId', headerName: t('search.voucherId'), width: 130,
            renderCell: (params: GridCellParams) => {
                if (params.value) {
                    return <Chip variant="outlined" size="small" icon={< ReceiptLong />} label={params.value} color="warning" />;
                } else {
                    return "";
                }
            }
        },
        { field: 'debitAccount', headerName: t('search.debet'), width: 120, sortable: false, renderCell: CellPopper },
        { field: 'creditAccount', headerName: t('search.credit'), width: 120, sortable: false, renderCell: CellPopper },
        { field: 'department', headerName: t('search.department'), width: 170, sortable: false, renderCell: CellPopper },
        { field: 'project', headerName: t('search.project'), width: 170, sortable: false, renderCell: CellPopper },
        { field: 'valueDate', headerName: t('search.valueDate'), width: 120, sortable: false, renderCell: CellPopper },
        { field: 'createdDate', headerName: t('search.created'), width: 120, },
        { field: 'comment', headerName: t('basic.comment'), width: 140, flex: 1, renderCell: CellPopper },

    ];

    function CustomErrorOverlay() {
        return <Grid container direction="column" justifyContent="center" alignItems="center" height="100%">
            <Grid><Error fontSize="large"/></Grid>
            <Grid width="15rem" display="flex" justifyContent="center">
                <Typography variant="body2">
                    {t("basic.unexpectedError")}
                </Typography>
            </Grid>
        </Grid>
    }

    let disableCreate = props.site === "Miscellaneous" ? false : true;

    return <><DataGrid css={stripedDateGrid(theme, theme.palette.grey[200])}
        onRowClick={
            (rowData) => handleDialogOpen(voucherRegistrations.find(v => v.id === rowData.row.id), false)
        }
        rows={gridRows ? gridRows : []}
        pagination
        paginationMode="server"
        pageSize={voucherRegistrationLimitPerPage}
        onPageChange={(newPage) => {
            setVoucherRegistrationPageNum(newPage);
        }}
        onPageSizeChange={(newSize) => {
            setVoucherRegistrationLimitPerPage(newSize);
        }}
        rowCount={voucherRegistrationTotalItems}
        columns={columns}
        rowHeight={remToPixels(2)}
        loading={loader}
        headerHeight={remToPixels(4)}
        getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        checkboxSelection
        onSelectionModelChange={(newSelectionModel) => {
            setVoucherRegistrationSelection(newSelectionModel);
        }}
        selectionModel={voucherRegistrationSelection}
        disableSelectionOnClick
        keepNonExistentRowsSelected 
        error={gridRowsErrors && gridRowsErrors.length > 0 ? true : undefined}
        localeText={{
            toolbarColumns: t("muiDatagrid.columns"),
            toolbarColumnsLabel: t("muiDatagrid.columnsLabel"),
            columnsPanelTextFieldPlaceholder: t("muiDatagrid.columnTitle"),
            columnsPanelTextFieldLabel: t("muiDatagrid.columnFind"),
            columnsPanelShowAllButton: t("muiDatagrid.showAll"),
            columnsPanelHideAllButton: t("muiDatagrid.hideAll"),

            toolbarExport: t("muiDatagrid.export"),
            toolbarExportLabel: t("muiDatagrid.exportLabel"),
            toolbarExportCSV: t("muiDatagrid.exportCSV"),
            toolbarExportPrint: t("muiDatagrid.exportPrint"),
            toolbarExportExcel: t("muiDatagrid.exportExcel"),
        }}
        components={{
            ErrorOverlay: CustomErrorOverlay,
            Toolbar: DatagridVoucherRegistrationToolbar,
        }}
        componentsProps={{
            toolbar: {
                disableCreate,
                handlePrint,
                handleNewDocument,
                handleClearAndUpdateDatagrid,
                handleCorrect,
                searchSimple,
                handleSearchSimple,
                openAdvancedSearch,
                handleOpenAdvnacedSearchToggle,
                status,
                handleUpdateStatus,
                invoiceNo,
                handleInvoiceNo,
                voucherDateFrom,
                handleVoucherDateFrom,
                voucherDateTo,
                handleVoucherDateTo,
                dueDateFrom,
                handleDueDateFrom,
                dueDateTo,
                handleDueDateTo,
                amountFrom,
                handleAmountFrom,
                amountTo,
                handleAmountTo,
                voucherNoFrom,
                handleVoucherNoFrom,
                voucherNoTo,
                handleVoucherNoTo,
                debet,
                handleDebet,
                credit,
                handleCredit,
                department,
                handleDepartment,
                project,
                handleProject,
                valueDateFrom,
                handleValueDateFrom,
                valueDateTo,
                handleValueDateTo,
                createdDateFrom,
                handleCreatedDateFrom,
                createdDateTo,
                handleCreatedDateTo,
                comment,
                handleComment,
                voucherRegistrationSelection,
                site,
            }
        }} />
        {chosenDocument && <DialogVoucherRegistration
            open={openDialog}
            closeDialog={handleDialogClose}
            initialDocument={chosenDocument}
            initialDocumentList={voucherRegistrations}
            initialDocumentListIndex={voucherRegistrations.findIndex(e => e.id === chosenDocument.id)}
            createNew={createNew}
            banking={site === "Banking" ? true : false} />}

    </>
}

export default DatagridVoucherRegistration;